module.exports = __webpack_public_path__ + "static/media/puntos-piso.f80decad.svg";